import { render, staticRenderFns } from "./YellowHeartSVG.vue?vue&type=template&id=e84c3b40&scoped=true&"
import script from "./YellowHeartSVG.vue?vue&type=script&lang=js&"
export * from "./YellowHeartSVG.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e84c3b40",
  null
  
)

export default component.exports